import Breadcrumb from "../Component/Breadcrumb";
const SchoolCabinet = () => {
  return (
    <>
      <Breadcrumb
        breadtitle="School Cabinet"
        breadmid="Office Bearers"
        breadend="School Cabinet"
      />
      <div className="innerpage library_blk">
        <div className="container">
          <div class="row">
            <div class="col-xl-4 col-lg-4 col-md-12 d-flex">
              <div class="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/sch-c4.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/sch-c4.jpg"
                  />
                </a>
              </div>
            </div>

                        <div class="col-xl-4 col-lg-4 col-md-12 d-flex">
              <div class="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/sch-c5.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/sch-c5.jpg"
                  />
                </a>
              </div>
            </div>

                        <div class="col-xl-4 col-lg-4 col-md-12 d-flex">
              <div class="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/sch-c6.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/sch-c6.jpg"
                  />
                </a>
              </div>
            </div>








            <div class="col-xl-4 col-lg-4 col-md-12 d-flex">
              <div class="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/sch-c2.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/sch-c2.jpg"
                  />
                </a>
              </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-12 d-flex">
              <div class="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/sch-c3.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/sch-c3.jpg"
                  />
                </a>
              </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-12 d-flex">
              <div class="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/s16.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/s16.jpg"
                  />
                </a>
              </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-12 d-flex">
              <div class="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/s17.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/s17.jpg"
                  />
                </a>
              </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-12 d-flex">
              <div class="img-box">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/s19.jpg"
                >
                  <img
                    alt="Canossa School Lucknow"
                    class="img-fluid"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/s19.jpg"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SchoolCabinet;
